import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../state/root-reducer';
import { AppDispatch } from '../state/store';
import { 
  setSelectedEstimate, 
  clearSelectedEstimate,
  setSelectedEstimateLoading,
  setSelectedEstimateError,
  clearSelectedEstimateError,
  setSavedEstimatesList,
  clearSavedEstimatesList,
  setSavedEstimatesListLoading,
  setSavedEstimatesListError,
  clearSavedEstimatesListError
} from '../state/estimator-slice';
import { loadSelectedEstimate, saveSelectedEstimate, createSelectedEstimate, loadSavedEstimatesListv3 } from '../state/estimator-thunk';
import { Estimate, Id } from '@finpay-estimation/estimation-types';

export const useEstimatorContext = () => {
  const dispatch = useDispatch<AppDispatch>();
  
  const { selectedEstimate, savedEstimatesList, isLoading, error } = useSelector(
    (state: RootState) => state.estimatorContext
  );

  return {
    // State
    selectedEstimate,
    savedEstimatesList,
    isLoading: {
      selectedEstimate: isLoading.selectedEstimate,
      savedEstimatesList: isLoading.savedEstimatesList,
    },
    error: {
      selectedEstimate: error.selectedEstimate,
      savedEstimatesList: error.savedEstimatesList,
    },
    
    // Selected Estimate Actions
    setSelectedEstimate: (estimate: Estimate | null) => dispatch(setSelectedEstimate(estimate)),
    clearSelectedEstimate: () => dispatch(clearSelectedEstimate()),
    setSelectedEstimateLoading: (loading: boolean) => dispatch(setSelectedEstimateLoading(loading)),
    setSelectedEstimateError: (error: string | null) => dispatch(setSelectedEstimateError(error)),
    clearSelectedEstimateError: () => dispatch(clearSelectedEstimateError()),
    
    // Saved Estimates List Actions
    setSavedEstimatesList: (estimates: Estimate[]) => dispatch(setSavedEstimatesList(estimates)),
    clearSavedEstimatesList: () => dispatch(clearSavedEstimatesList()),
    setSavedEstimatesListLoading: (loading: boolean) => dispatch(setSavedEstimatesListLoading(loading)),
    setSavedEstimatesListError: (error: string | null) => dispatch(setSavedEstimatesListError(error)),
    clearSavedEstimatesListError: () => dispatch(clearSavedEstimatesListError()),
    
    // Async actions
    loadEstimate: (config: { paramId: number; estimationId: number | string }) => 
      dispatch(loadSelectedEstimate(config)),
    saveEstimate: (config: { estimate: Estimate; estimateId?: Id }) => 
      dispatch(saveSelectedEstimate(config)),
    createEstimate: (estimate: Estimate) => 
      dispatch(createSelectedEstimate(estimate)),
    loadSavedEstimatesListv3: (config: { paramId: number; patientId: number }) => 
      dispatch(loadSavedEstimatesListv3(config)),
  };
}; 